import { createApiRequest } from "../common";
import { DeclineOrgInviteRequestContent } from '@equaliq/api-model-v2';

export const declineOrgInviteApi = async (request: DeclineOrgInviteRequestContent): Promise<void> => {
  const apiRequest = createApiRequest<void>('post', '/orgs/invites/decline');
  return apiRequest(request);
};